export const COURSES_LOAD = '@courses/load';
export const COURSES_OPEN = '@courses/open';
